// The weekly digest's screens (Stage 4.6c, guide §6.11): where each tip's "Fix it" goes, and how a week's change reads. Pure, so
// scripts/check-insights.cjs can prove the links are exactly the server's (server/ai/digest.js LINKS).

// A tip's link → the page (a SideBar view) and, inside Analytics, its tab.
export const LINK_VIEWS = Object.freeze({
  working_hours: { view: "profile" },
  call_flow: { view: "callflow" },
  agents: { view: "agents" },
  team: { view: "representatives" },
  ai_persona: { view: "persona" },
  knowledge_base: { view: "knowledge" },
  catalog: { view: "catalog" },
  order_settings: { view: "ordersettings" },
  follow_ups: { view: "aiactions" },
  whatsapp: { view: "whatsapp" },
  top_up: { view: "billing" },
  missed_calls: { view: "analytics", tab: "missed" },
  customers: { view: "analytics", tab: "customers" },
  ai_quality: { view: "analytics", tab: "aiquality" },
  agents_performance: { view: "analytics", tab: "agents" },
});

// The five, in the order the message and the screen give them; which way is good for each.
export const FIVE = Object.freeze([
  { key: "calls", better: null },
  { key: "missed", better: "down" },
  { key: "aiAlone", better: "up" },
  { key: "bookingsOrders", better: "up" },
  { key: "handoffs", better: null },
]);

// A week against the week before: the difference and whether it is good news, bad news or neither.
export function changeOf(now, before, better) {
  const a = Number(now) || 0, b = Number(before) || 0, d = a - b;
  const tone = !d || !better ? "flat" : (d > 0) === (better === "up") ? "good" : "bad";
  return { delta: d, text: d === 0 ? "=" : `${d > 0 ? "+" : "−"}${Math.abs(d)}`, tone };
}

// The Analytics tab a page should open on, handed over once: by a link (?view=analytics&tab=…), the Dashboard's banner, or a tip.
export const TAB_HINT_KEY = "trd_analyticsTab";
export function takeTabHint() {
  try { const t = sessionStorage.getItem(TAB_HINT_KEY); if (t) sessionStorage.removeItem(TAB_HINT_KEY); return t; } catch { return null; }
}
export function giveTabHint(tab) {
  try { if (tab) sessionStorage.setItem(TAB_HINT_KEY, tab); } catch { /* the tab opens on its default */ }
}
